import { render } from "./MessengerIntegrationView.vue?vue&type=template&id=29cf6764&scoped=true"
import script from "./MessengerIntegrationView.vue?vue&type=script&lang=js"
export * from "./MessengerIntegrationView.vue?vue&type=script&lang=js"

import "./MessengerIntegrationView.vue?vue&type=style&index=0&id=29cf6764&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29cf6764"]])

export default __exports__